export default __webpack_public_path__ + "static/media/danishgot-screenshot-01.f67da21f.png";